// Remove custom style var and sx prop
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import SSOLink from '~/components/SSOLink';
import WordPressIcon from '~/scenes/Sites/assets/icons/WordPressIcon';

type SiteInstalledModalPropOptions = {
  open: boolean;
  newSiteId?: string;
};

const SiteInstalledModal = ({
  open,
  newSiteId = undefined,
}: SiteInstalledModalPropOptions) => {
  useTranslation('launchSiteTypeModal');
  const { t } = useTranslation(['addSites', 'site']);
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      keepMounted
      aria-describedby="site-installed-dialog-description"
      maxWidth={'sm'}
      fullWidth
    >
      <DialogContent sx={{ maxWidth: 400, margin: '0 auto', py: 5 }}>
        <Stack spacing={3} alignContent={'center'} textAlign={'center'}>
          <Stack
            direction="row"
            spacing={1}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <CheckCircleIcon color="success" />
            <Typography variant="h2">{t('installedModal.header')}</Typography>
          </Stack>

          <Typography>{t('installedModal.descriptionWP')}</Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent={'center'}
          >
            <Button
              variant="outlined"
              onClick={() => navigate(`/sites/${newSiteId}`)}
            >
              {t('installedModal.manageBtn')}
            </Button>
            <SSOLink
              type="site"
              variant="contained"
              id={newSiteId}
              onAction={() => navigate(`/sites/${newSiteId}`)}
              startIcon={<WordPressIcon color="#fff" />}
            >
              {t('installedModal.wordpressBtn')}
            </SSOLink>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SiteInstalledModal;
